import { UserSettings } from '@asa/asasqt-microfrontend-components/dist/common/types';
import { PriceSettingsValues } from '@asa/asasqt-microfrontend-components/dist/common/types/shared/auth';

export const sanitizeUserSettings = (
  settings: UserSettings,
  hasStockAndPrice: boolean,
  hasDmsTransferCapability: boolean
): UserSettings => {
  const sanitized = { ...settings };

  if (!hasStockAndPrice) {
    if (sanitized.useDmsPrice) {
      sanitized.prices = PriceSettingsValues.NoPrices;
    }
    sanitized.useDmsPrice = false;
    sanitized.showStockAvailability = false;
  }

  if (!hasDmsTransferCapability) {
    sanitized.transferDescriptionsInCapital = false;
  }

  return sanitized;
};
